import app from '../app';
import Toast from './toast';
import Captcha from './captcha';
// import loginBox from './loginBox';

import './btn';
import './ckediterFold';
import './intersectionObserver';
import './pageHeader';
import './productBar';
import './switchLineEllipsis';
import './svgSNS';
import './sidebarNavCollapse';

if (!app.comp) {
  app.comp = {
    toast: new Toast(),
    Captcha,
    // loginBox,
  };
}
// window.loginBox = loginBox;
